import React from 'react';

var KiotSpinner = null;
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Checkbox from 'material-ui/Checkbox';

import Box from '../ui/Box';

import DataService from '../../services/DataService'; var ds = DataService;
import LocalStorageService from '../../services/LocalStorageService'; var ls = LocalStorageService;

// var FOOD_ITEM_GROUPS = [
//   "Breakfast",
//   "Lunch",
//   "Dinner",
//   "Snacks",
//   "Beverages",
//   "All Day"
// ];


export default class NewFoodItem extends React.Component {

  constructor(props) {
    super(props);
    let x = new Date();
    this.state = {
      name: this.props.details ? this.props.details.name : "",
      price: this.props.details ? this.props.details.price : "",
      spinner: null,
      items: [],
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    };
  }

  componentDidMount() {
    this.setItems();
  }

  setItems() {
    if (this.props.details && this.props.details.groups && this.props.details.groups.length) {
      let x = this.state.items;
      for (let i of this.props.details.groups) {
        x.push(i);
      }
      this.setState({
        items: x
      })
    }
  }

  handleChanges(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  closeDialog() {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    })
  }

  createFoodItem(e) {
    e.preventDefault()
    if (this.validated()) {
      this.setState({
        spinner: <KiotSpinner />
      })

      if (this.props.details && this.props.details._id) {
        ds.postEditFoodItem({
          hotel_id: ls.getUserDetails().hotel_id,
          item_id: this.props.details._id,
          item: {
            name: this.state.name,
            price: parseInt(this.state.price),
            groups: this.getGroups()
          }
        }, 
          data => {
            this.props.unMountMe(true);
            this.setState({
              name: "",
              price: "",
              spinner: null
            });
          }, 
          err => {}
        );

      } else {
        ds.postCreateFoodItem({
          item: {
            name: this.state.name,
            price: this.state.price,
            groups: this.getGroups()
          },
          hotel_id: ls.getUserDetails().hotel_id
        }, 
        data => {
          let dialog = {
            open: true,
            head: 'Success',
            body: "Food Item added",
            actions: [
              <FlatButton
                label="Okay"
                primary
                onClick={this.closeDialog.bind(this)}
              />
            ]
          }
          let evt = new CustomEvent('updateFoodMenuTable', { detail: true });
          window.dispatchEvent(evt);
          this.setState({
            name: '',
            price: '',
            dialog: dialog,
            items: []
          });
        }, 
        err => {
          this.setState({
            spinner: null
          })
        });
      }
    }
  }

  getGroups() {
    let groups = [];
    let items = this.state.items;
    for (let i in items) {
      if (items[i]) {
        groups.push(items[i]);
      }
    }
    return groups;
  }

  validated() {
    let dialog;
    let flag = true;
    if (!this.state.name || !this.state.price) {

      dialog = {
        open: true,
        head: 'Invalid',
        body: "All Fields are mandatory",
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
      flag = false;
    }

    if (!flag) {
      this.setState({
        dialog: dialog
      })
    }
    return flag;
  }

  render() {
    return (
      <Box header={this.props.details && this.props.details._id ? 'Edit Menu Item(s)' : 'Restaurant Menu Item'}>
        <Dialog
          title={this.state.dialog.head}
          autoScrollBodyContent={true}
          actions={this.state.dialog.actions}
          modal={false}
          open={this.state.dialog.open}
          onRequestClose={this.closeDialog.bind(this)}
        >
          {this.state.dialog.body || 'NA'}
        </Dialog>

        <div className="col-sm-12">
          <form className="smart-form " onSubmit={this.createFoodItem.bind(this)}>
            <fieldset>
              <section>
                <TextField
                  floatingLabelText="Name"
                  name="name"
                  className="w-100"
                  value={this.state.name}
                  onChange={this.handleChanges.bind(this)}
                />
              </section>

              <section>
                <TextField
                  floatingLabelText="Price"
                  name="price"
                  className="w-100"
                  type="number"
                  value={this.state.price}
                  onChange={this.handleChanges.bind(this)}
                />
              </section>

              <br />
              <section>
                <TextField
                  floatingLabelText="Group"
                  name="group"
                  className="w-100"
                  onChange={(e)=>{let x=[e.target.value];this.setState({items:x})}}
                />
              </section>


              {/* <section>
                <div>Group(s)</div>
                <br />

                {
                  FOOD_ITEM_GROUPS.map(
                    (item, ind) => {
                      return (
                        <div className="col-sm-6">
                          <Checkbox label={item} key={ind} checked={this.state.items[item]}
                            onCheck={
                              (e) => {
                                let x = this.state.items;
                                x[item] = e.target.checked ? true : false;
                                this.setState({
                                  items: x
                                })
                              }
                            } />
                        </div>
                      )
                    }
                  )
                }
              </section> */}
            </fieldset>

            <div className="mt-4vw align-right">
              <RaisedButton
                label="Save"
                primary
                type="submit"
              />
              <span className="space"></span>
              {
                this.props.details ?
                  <FlatButton
                    label="Cancel"
                    primary
                    onClick={this.props.unMountMe.bind(this, false)}
                    type="button"
                  /> 
                : null
              }
            </div>
          </form>

        </div>
      </Box>
    )
  }
}


// WEBPACK FOOTER //
// ./components/food/NewFoodItem.js